"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _DropdownSubmenu = _interopRequireDefault(require("../dropdown/DropdownSubmenu"));

var _DropdownHeader = _interopRequireDefault(require("../selects/DropdownHeader"));

var MenuItem = function MenuItem(props) {
  var value = props.value,
      divider = props.divider,
      disabled = props.disabled,
      active = props.active,
      onSelect = props.onSelect,
      header = props.header,
      index = props.index,
      closeMenu = props.closeMenu,
      onMouseEnter = props.onMouseEnter;

  if (value && value.type === _DropdownSubmenu.default) {
    return value;
  }

  var role = divider ? 'separator' : 'presentation';
  var classes = (0, _classnames.default)(divider && 'divider pointer-events-none', disabled && 'disabled', active && 'active');

  var menuLink = /*#__PURE__*/_react.default.createElement("a", {
    role: 'menuitem'
  }, value);

  var onSelectItem = function onSelectItem(event) {
    if (!disabled) {
      onSelect(index, event);

      if (closeMenu) {
        closeMenu();
      }
    }
  };

  var onItemMouseEnter = function onItemMouseEnter(event) {
    if (!disabled) {
      onMouseEnter(event);
    }
  };

  if (header) {
    return /*#__PURE__*/_react.default.createElement(_DropdownHeader.default, {
      label: value,
      center: false
    });
  }

  return /*#__PURE__*/_react.default.createElement("li", {
    role: role,
    className: classes,
    onClick: onSelectItem,
    onMouseEnter: onItemMouseEnter,
    "data-item-index": index
  }, header ? value : menuLink);
};

MenuItem.defaultProps = {
  disabled: false,
  onSelect: function onSelect() {},
  closeMenu: function closeMenu() {},
  onMouseEnter: function onMouseEnter() {}
};
MenuItem.propTypes = {
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
  disabled: _propTypes.default.bool,
  divider: _propTypes.default.bool,
  header: _propTypes.default.bool,
  onSelect: _propTypes.default.func,
  index: _propTypes.default.number,
  closeMenu: _propTypes.default.func,
  onMouseEnter: _propTypes.default.func
};
var _default = MenuItem;
exports.default = _default;